/* global $ */

export class FeaturedParts {
	constructor(el) {
		// carousel
		$(el).find('.carousel').slick()
	}
}
